(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cocomo-99-announcement-bar"] && !Shopify.designMode) return;
  try {
    (function () {
  var bar = document.getElementById('c99-announcement-bar');
  if (!bar || !bar.classList.contains('c4-launch-bar') || bar.dataset.c4Ready) return;
  bar.dataset.c4Ready = 'true';
  var root = document.documentElement;
  var key = 'cocomo-week4-launch-announcement-dismissed';
  function syncHeight() {
    root.style.setProperty('--cocomo-sticky-announcement-height', (bar.hidden ? 0 : bar.getBoundingClientRect().height) + 'px');
  }
  root.classList.add('c99-announcement-active');
  try {
    if (sessionStorage.getItem(key) === '1') bar.hidden = true;
  } catch (error) {}
  syncHeight();
  var close = bar.querySelector('.c4-launch-bar__close');
  if (close) close.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    bar.hidden = true;
    syncHeight();
    try { sessionStorage.setItem(key, '1'); } catch (error) {}
    var menu = document.querySelector('[data-drawer-id="sidebar-menu"]');
    if (menu && menu.getClientRects().length) menu.focus();
  });
  if ('ResizeObserver' in window) new ResizeObserver(syncHeight).observe(bar);
  else window.addEventListener('resize', syncHeight, { passive: true });
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cocomo-baby-controller"] && !Shopify.designMode) return;
  try {
    (function(){
 function mount(root){
  if(root.dataset.babyReady)return;root.dataset.babyReady='true';
  const grid=root.querySelector('[data-baby-grid]'),cards=Array.from(root.querySelectorAll('[data-baby-product]'));
  const form=root.querySelector('[data-baby-filters]'),search=root.querySelector('[data-baby-search]'),brand=root.querySelector('[data-baby-brand]'),stock=root.querySelector('[data-baby-availability]'),sort=root.querySelector('[data-baby-sort]');
  const views=new Map(Array.from(root.querySelectorAll('[data-baby-view]')).map(t=>[t.dataset.babyView,t]));
  const words=JSON.parse(root.querySelector('[data-baby-strings]').textContent),empty=root.querySelector('[data-baby-empty]');
  let category=root.dataset.initialCategory;
  const familyOf=h=>h.startsWith('kids-shampoo')||h==='kids-conditioner'||h==='kids-haircare'?'kids-haircare':h==='kids-skincare'||h==='kids-moisturiser'||h==='kids-sun'?'kids-skincare':h==='baby-feeding-accessories'?h:'baby-kids';
  const belongs=(card,h)=>h==='baby-kids'||card.dataset.categories.split('|').includes(h);
  function readUrl(){const p=new URL(location.href).searchParams,cat=p.get('baby_category');const pathCategory=location.pathname.split('/').filter(Boolean).pop();category=views.has(cat)?cat:views.has(pathCategory)?pathCategory:root.dataset.initialCategory;search.value=p.get('baby_q')||'';brand.value=p.get('baby_brand')||'';stock.value=p.get('baby_stock')||'';sort.value=p.get('baby_sort')||'featured';if(!sort.value)sort.value='featured';}
  function saveUrl(push){const u=new URL(location.href);u.pathname=root.dataset.rootUrl;u.hash='';['baby_category','baby_q','baby_brand','baby_stock','baby_sort','page'].forEach(k=>u.searchParams.delete(k));if(category!=='baby-kids')u.searchParams.set('baby_category',category);if(search.value.trim())u.searchParams.set('baby_q',search.value.trim());if(brand.value)u.searchParams.set('baby_brand',brand.value);if(stock.value)u.searchParams.set('baby_stock',stock.value);if(sort.value!=='featured')u.searchParams.set('baby_sort',sort.value);if(u.href!==location.href)history[push?'pushState':'replaceState']({},'',u.href);}
  function renderView(){const template=views.get(category);if(!template)return;['hero','guide','footer'].forEach(part=>{const target=root.querySelector('[data-baby-target="'+part+'"]'),source=template.content.querySelector('[data-baby-part="'+part+'"]');target.replaceChildren(source.cloneNode(true));});root.querySelector('[data-baby-target="hero"] h1').id='BabyTitle';root.querySelector('[data-baby-crumb]').textContent=category==='baby-kids'?'':' / '+template.dataset.label;
   const family=familyOf(category);
   root.querySelectorAll('.bk-families [data-baby-category]').forEach(a=>{if(a.dataset.babyCategory===family)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');});
   root.querySelectorAll('[data-baby-format]').forEach(a=>{const h=a.dataset.babyFormat;if(h==='baby-kids'){a.dataset.babyCategory=family;a.href=root.dataset.rootUrl+(family==='baby-kids'?'':'?baby_category='+encodeURIComponent(family));const label=a.querySelector('span');if(label)label.textContent=String(cards.filter(c=>belongs(c,family)).length);}a.hidden=h!=='baby-kids'&&family!=='baby-kids'&&familyOf(h)!==family;if(a.dataset.babyCategory===category)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');});
  }
  function apply(){const q=search.value.trim().toLocaleLowerCase(),matches=cards.filter(c=>belongs(c,category)&&(!q||c.dataset.search.includes(q))&&(!brand.value||c.dataset.brand===brand.value)&&(!stock.value||c.dataset.available===stock.value));
   if(sort.value==='price-ascending')matches.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));else if(sort.value==='price-descending')matches.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));else if(sort.value==='title-ascending')matches.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title));else if(sort.value==='created-descending')matches.sort((a,b)=>Number(b.dataset.created)-Number(a.dataset.created));else matches.sort((a,b)=>Number(a.dataset.order)-Number(b.dataset.order));
   cards.forEach(c=>c.hidden=true);const fragment=document.createDocumentFragment();matches.forEach((c,i)=>{c.hidden=false;fragment.append(c);});grid.append(fragment);root.querySelector('[data-baby-count]').textContent=matches.length+' '+words[matches.length===1?'product':'products'];empty.hidden=matches.length>0;const categoryEmpty=!cards.some(c=>belongs(c,category));root.querySelector('[data-baby-empty-heading]').textContent=words[categoryEmpty?'empty_category':'empty_filtered'];root.querySelector('[data-baby-empty-text]').textContent=words[categoryEmpty?'empty_category_text':'empty_filtered_text'];root.querySelector('[data-baby-reset]').hidden=categoryEmpty;}
  function scrollToGuide(){const target=root.querySelector('#baby-guide');if(!target)return;const header=document.querySelector('#shopify-section-header, .shopify-section--header, .Header');const rect=header?header.getBoundingClientRect():null;const offset=rect&&rect.bottom>0?Math.min(rect.bottom,window.innerHeight*.4)+18:24;window.scrollTo({top:window.scrollY+target.getBoundingClientRect().top-offset,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}
  root.addEventListener('click',e=>{const link=e.target.closest('[data-baby-category]');if(!link||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||root.dataset.complete!=='true')return;const h=link.dataset.babyCategory;if(!views.has(h))return;e.preventDefault();category=h;form.reset();renderView();apply();saveUrl(true);scrollToGuide();});
  form.addEventListener('submit',e=>{e.preventDefault();apply();saveUrl(false);});form.addEventListener('input',()=>{apply();saveUrl(false);});form.addEventListener('change',()=>{apply();saveUrl(false);});form.addEventListener('reset',()=>{queueMicrotask(()=>{apply();saveUrl(false);});});root.querySelector('[data-baby-reset]').addEventListener('click',()=>form.reset());
  window.addEventListener('popstate',()=>{if(!document.contains(root))return;readUrl();renderView();apply();});
  readUrl();renderView();apply();
 }
 const start=scope=>scope.querySelectorAll('[data-baby-hub]').forEach(mount);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(document),{once:true});else start(document);document.addEventListener('shopify:section:load',e=>start(e.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cocomo-discovery-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';

  const rootSelector = '.cds-shelf[data-cds-kind="recommendations"], .cds-shelf[data-cds-kind="recently-viewed"]';
  const mountEvent = 'cocomo:discovery:mount';
  if (document.documentElement.dataset.cdsRuntime === 'true') {
    document.dispatchEvent(new Event(mountEvent));
    return;
  }
  document.documentElement.dataset.cdsRuntime = 'true';

  const instances = new WeakMap();
  const historyKey = 'recentlyViewedProducts';
  const historyLimit = 8;
  const alignmentSelectors = [
    '.CocomoCollectionCard__Media',
    '.CocomoCollectionCard__Flair',
    '.ProductItem__Title > a',
    '.opinew-stars-plugin-product-list',
    '.ProductItem__PriceList'
  ];

  function productId(value) {
    if (typeof value !== 'string' && typeof value !== 'number') return null;
    if (typeof value === 'string' && !/^\d+$/.test(value)) return null;
    const number = Number(value);
    return Number.isSafeInteger(number) && number > 0 ? String(number) : null;
  }

  function recentIds(currentId) {
    let values = [];
    try {
      const stored = JSON.parse(localStorage.getItem(historyKey) || '[]');
      if (Array.isArray(stored)) values = stored;
    } catch (_) {
    }
    const ids = [...new Set(values.map(productId).filter(Boolean))];
    if (currentId) {
      const index = ids.indexOf(currentId);
      if (index !== -1) ids.splice(index, 1);
      ids.unshift(currentId);
    }
    const latest = ids.slice(0, historyLimit);
    try {
      localStorage.setItem(historyKey, JSON.stringify(latest.map(Number)));
    } catch (_) {}
    return latest.filter(id => id !== currentId);
  }

  function endpoint(value) {
    if (!value) return null;
    try {
      const url = new URL(value, location.href);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol) || url.username || url.password) return null;
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url;
    } catch (_) {
      return null;
    }
  }

  function cardsIn(track) {
    return [...track.children].filter(node => node.matches('article.cds-card[data-product-id]'));
  }

  function formatOfferPairs(track) {
    for (const label of track.querySelectorAll('.CocomoCollectionCard__Flair .flair-badge > div')) {
      if (label.querySelector('.cds-offer-line')) continue;
      const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const parts = node.textContent.match(/^(\s*ANY\s+\d+\s*\+\s*\d+(?:\.\d+)?%\s*OFF)(\s*,\s*)(ANY\s+\d+\s*\+\s*\d+(?:\.\d+)?%\s*OFF\s*)$/i);
        if (!parts) continue;
        const fragment = document.createDocumentFragment();
        for (let index = 1; index <= 3; index++) {
          const span = document.createElement('span');
          span.className = index === 2 ? 'cds-offer-separator' : 'cds-offer-line';
          span.textContent = parts[index];
          fragment.append(span);
        }
        node.replaceWith(fragment);
        break;
      }
    }
  }

  function parsedCards(html, kind, order) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const tracks = parsed.querySelectorAll('.cds-shelf[data-cds-kind="' + kind + '"] .cds-track');
    const found = new Map();
    const allowed = order ? new Set(order) : null;
    for (const track of tracks) {
      for (const card of cardsIn(track)) {
        const id = productId(card.dataset.productId);
        if (!id || found.has(id) || (allowed && !allowed.has(id))) continue;
        const imported = document.importNode(card, true);
        for (const script of imported.querySelectorAll('script')) {
          if (script.classList.contains('bold-product-json')) {
            script.type = 'application/json';
            script.removeAttribute('src');
          } else if (!/^application\/(?:ld\+)?json$/i.test(script.type.trim())) {
            script.remove();
          }
        }
        found.set(id, imported);
      }
    }
    return order ? order.map(id => found.get(id)).filter(Boolean) : [...found.values()].slice(0, historyLimit);
  }

  function mount(root) {
    if (instances.has(root)) return;
    const track = root.querySelector('.cds-track');
    if (!track) return;

    const controller = new AbortController();
    const disposers = [];
    let stopped = false;
    let alignmentFrame = 0;
    let scrollFrame = 0;
    let alignedNodes = [];
    let trackWidth = 0;

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      disposers.push(() => target.removeEventListener(type, handler, options));
    }

    function updateNavigation() {
      scrollFrame = 0;
      if (stopped) return;
      const hasCards = !root.hidden && cardsIn(track).length > 0;
      for (const control of root.querySelectorAll('.cds-controls, .cds-progress')) control.hidden = !hasCards;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      const position = Math.min(maximum, Math.max(0, track.scrollLeft));
      for (const button of root.querySelectorAll('[data-cds-prev]')) button.disabled = maximum < 1 || position < 1;
      for (const button of root.querySelectorAll('[data-cds-next]')) button.disabled = maximum < 1 || position >= maximum - 1;
      const progress = track.scrollWidth > 0 ? Math.min(100, (position + track.clientWidth) / track.scrollWidth * 100) : 100;
      root.style.setProperty('--cds-progress', progress.toFixed(3) + '%');
    }

    function scheduleNavigation() {
      if (!stopped && !scrollFrame) scrollFrame = requestAnimationFrame(updateNavigation);
    }

    function alignCards() {
      alignmentFrame = 0;
      if (stopped || !root.isConnected || root.hidden || !track.getBoundingClientRect().width) return;
      formatOfferPairs(track);
      alignedNodes.forEach(node => node.style.removeProperty('--cds-row-height'));
      alignedNodes = [];
      const cards = cardsIn(track).filter(card => card.getClientRects().length);
      const badgeHeight = Math.max(0, ...cards.map(card => card.querySelector('.CocomoCollectionCard__TopBadges')?.getBoundingClientRect().height || 0));
      track.style.setProperty('--cds-badge-clearance', Math.ceil(badgeHeight / 2 + 2) + 'px');
      for (const selector of alignmentSelectors) {
        const nodes = cards.map(card => card.querySelector(selector)).filter(Boolean);
        const height = Math.ceil(Math.max(0, ...nodes.map(node => node.getBoundingClientRect().height)));
        if (!height) continue;
        nodes.forEach(node => {
          node.style.setProperty('--cds-row-height', height + 'px');
          alignedNodes.push(node);
        });
      }
      updateNavigation();
    }

    function scheduleAlignment() {
      if (!stopped && !alignmentFrame) alignmentFrame = requestAnimationFrame(alignCards);
    }

    function scrollToPosition(position) {
      const reduceMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
      const left = Math.max(0, Math.min(position, track.scrollWidth - track.clientWidth));
      if (typeof track.scrollTo === 'function') track.scrollTo({ left, behavior: reduceMotion ? 'auto' : 'smooth' });
      else track.scrollLeft = left;
      scheduleNavigation();
    }

    function page(direction) {
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap) || parseFloat(styles.gap) || 0;
      scrollToPosition(track.scrollLeft + direction * (track.clientWidth + gap));
    }

    for (const button of root.querySelectorAll('[data-cds-prev]')) listen(button, 'click', () => page(-1));
    for (const button of root.querySelectorAll('[data-cds-next]')) listen(button, 'click', () => page(1));
    listen(track, 'scroll', scheduleNavigation, { passive: true });
    listen(track, 'keydown', event => {
      if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        page(event.key === 'ArrowLeft' ? -1 : 1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        scrollToPosition(event.key === 'Home' ? 0 : track.scrollWidth);
      }
    });

    const observer = new MutationObserver(scheduleAlignment);
    observer.observe(track, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    const widthObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (Math.abs(width - trackWidth) > .5) {
        trackWidth = width;
        scheduleAlignment();
      }
    }) : null;
    widthObserver?.observe(track);
    listen(window, 'resize', scheduleAlignment);
    listen(track, 'load', scheduleAlignment, true);
    document.fonts?.ready.then(scheduleAlignment).catch(() => {});
    if (document.fonts?.addEventListener) listen(document.fonts, 'loadingdone', scheduleAlignment);

    instances.set(root, {
      destroy() {
        stopped = true;
        controller.abort();
        cancelAnimationFrame(alignmentFrame);
        cancelAnimationFrame(scrollFrame);
        observer.disconnect();
        widthObserver?.disconnect();
        disposers.forEach(dispose => dispose());
        alignedNodes.forEach(node => node.style.removeProperty('--cds-row-height'));
        track.style.removeProperty('--cds-badge-clearance');
        root.removeAttribute('aria-busy');
        instances.delete(root);
      }
    });

    function present() {
      const hasCards = cardsIn(track).length > 0;
      root.hidden = !hasCards;
      root.dataset.cdsState = hasCards ? 'ready' : 'empty';
      scheduleAlignment();
      updateNavigation();
    }

    async function load(url, kind, order) {
      root.hidden = true;
      root.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url.href, { method: 'GET', credentials: 'same-origin', redirect: 'error', signal: controller.signal });
        if (!response.ok) throw new Error('Unavailable product section');
        const html = await response.text();
        if (stopped) return;
        const cards = parsedCards(html, kind, order);
        track.replaceChildren(...cards);
        present();
        if (cards.length) root.dispatchEvent(new Event('cocomo:products:loaded', { bubbles: true }));
      } catch (_) {
        if (!stopped) {
          root.hidden = true;
          root.dataset.cdsState = 'unavailable';
        }
      } finally {
        if (!stopped) root.removeAttribute('aria-busy');
      }
    }

    if (root.dataset.cdsKind === 'recently-viewed') {
      const ids = recentIds(productId(root.dataset.cdsProductId));
      const url = endpoint(root.dataset.cdsUrl);
      root.hidden = true;
      if (!ids.length || !url) {
        root.dataset.cdsState = 'empty';
        updateNavigation();
        return;
      }
      url.searchParams.set('q', ids.map(id => 'id:' + id).join(' OR '));
      load(url, 'recently-viewed', ids);
      return;
    }

    if (cardsIn(track).length || root.dataset.cdsCurated === 'true' || root.dataset.cdsPerformed === 'true') {
      present();
      return;
    }
    const url = endpoint(root.dataset.cdsUrl);
    if (url) load(url, 'recommendations');
    else present();
  }

  function rootsWithin(scope) {
    const roots = [...scope.querySelectorAll(rootSelector)];
    if (scope.matches?.(rootSelector)) roots.unshift(scope);
    return roots;
  }

  function mountWithin(scope) {
    rootsWithin(scope).forEach(mount);
  }

  document.addEventListener('shopify:section:load', event => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    rootsWithin(event.target).forEach(root => instances.get(root)?.destroy());
  });
  document.addEventListener(mountEvent, () => mountWithin(document));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mountWithin(document), { once: true });
  else mountWithin(document);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cocomo-hair-body-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const root = document.querySelector('[data-hb-root]');
  if (!root || root.dataset.hbMounted) return;
  root.dataset.hbMounted = 'true';
  const $ = id => root.querySelector('#hb-' + id);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const decode = value => { const node = document.createElement('textarea'); node.innerHTML = String(value ?? ''); return node.value; };
  const decodeData = value => typeof value === 'string' ? decode(value) : Array.isArray(value) ? value.map(decodeData) : value && typeof value === 'object' ? Object.fromEntries(Object.entries(value).map(([key, item]) => [key, decodeData(item)])) : value;
  let D, registry, copy;
  try {
    D = decodeData(JSON.parse(document.getElementById('hb-data').textContent));
    const routes = decodeData(JSON.parse(document.getElementById('hb-route-data').textContent));
    registry = Object.fromEntries((Array.isArray(routes) ? routes : Object.values(routes)).map(route => [route.handle, { ...route, parent: route.parent || route.parentfamilyhandle || null, formats: route.formats || [], concerns: route.concerns || [] }]));
    copy = decodeData(JSON.parse(document.getElementById('hb-view-copy').textContent));
  } catch (_) { return; }
  const G = D.guides || {}, T = D.formats, GROUPS = D.groups || {};
  const routes = Object.values(registry), familyRoutes = routes.filter(route => route.kind === 'family');
  const allRoute = familyRoutes.find(route => route.family === 'all');
  if (!allRoute || routes.some(route => !copy[route.handle])) return;
  const familyHandles = Object.fromEntries(familyRoutes.map(route => [route.family, route.handle]));
  const fields = ['q', 'format', 'brand', 'sort', 'availability', 'min', 'max', 'concern', 'model', 'kids'];
  const blank = (category = allRoute.handle) => ({ category, page: registry[category]?.family || 'all', group: 'all', q: '', format: '', brand: '', sort: 'curated', availability: '', min: '', max: '', concern: '', model: '', kids: '' });
  const artwork = new Map([...document.querySelectorAll('template[data-hb-art]')].map(node => [node.dataset.hbArt, node]));
  const originalOptions = Object.fromEntries(['format', 'brand', 'concern', 'model'].map(id => [id, $(id).options[0].textContent]));
  const originalLabels = Object.fromEntries(['concern', 'model'].map(id => [id, Object.fromEntries([...$(id).options].filter(option => option.value).map(option => [option.value, option.textContent]))]));
  const originalPillLabels = { kicker: $('pills').closest('.pill-section')?.querySelector('.section-kicker')?.textContent || '', group: $('pills').getAttribute('aria-label') || '' };
  const resultHeading = $('results-title').textContent;
  const cards = new Map([...root.querySelectorAll('[data-hair-body-product]')].map(card => [card.dataset.hairBodyProduct, card]));
  const pending = new Map();
  let nativePage = readNativePage();
  let P = [], state = blank(), shown = nativePage * 12, current = [], version = 0, navToken = 0, loaded = false, timer = 0, destination = '', navFrame = 0, categoryKey = null, historyMode = 'replace';

  function url(path) {
    const next = new URL(path, location.origin), now = new URL(location.href);
    if (next.origin !== location.origin) throw Error('Invalid storefront URL');
    ['preview_theme_id', '_fd', 'pb'].forEach(key => { if (now.searchParams.has(key)) next.searchParams.set(key, now.searchParams.get(key)); });
    return next;
  }
  function routeHref(handle, hash = '') {
    const target = url(root.dataset.sourceUrl);
    if (handle !== allRoute.handle) target.searchParams.set('hb_category', handle);
    target.hash = hash;
    return target.pathname + target.search + target.hash;
  }
  function pathHandle(pathname) { return pathname.match(/(?:^|\/)collections\/([^/]+)\/?$/)?.[1] || ''; }
  function routeForLink(link) {
    if (link.closest('#hb-native-pagination')) return null;
    try {
      const target = url(link.href), explicit = link.dataset.hbCategory || target.searchParams.get('hb_category');
      if (explicit && registry[explicit]) return registry[explicit];
      const family = link.dataset.hbFamily || target.searchParams.get('hb_family');
      if (family && familyHandles[family]) return registry[familyHandles[family]];
      return registry[pathHandle(target.pathname)] || null;
    } catch (_) { return null; }
  }
  function readNativePage() {
    const page = Number(new URL(location.href).searchParams.get('page') || 1);
    const pages = Number($('native-pagination')?.dataset.pages || 1);
    return Number.isInteger(page) && page > 1 ? Math.min(page, Math.max(1, pages)) : 1;
  }
  function prepareFamilyLinks() {
    document.querySelectorAll('a[href]').forEach(link => {
      if (link.getAttribute('href').startsWith('#')) return;
      const route = routeForLink(link);
      if (!route) return;
      const target = new URL(link.href, location.origin);
      link.dataset.hbCategory = route.handle;
      link.href = routeHref(route.handle, target.hash);
    });
  }
  function pageFamily(page = state.page) { return page === 'concern' ? 'hair' : page; }
  function selectedRoute() { return registry[state.category] || allRoute; }
  function familyRoute(route = selectedRoute()) { return route.kind === 'family' ? route : registry[route.parent] || registry[familyHandles[route.family]] || allRoute; }
  function routeEligible(v, route) {
    if (route.handle === allRoute.handle) return true;
    if (Array.isArray(v.families) && !v.families.includes(route.family === 'concern' ? 'hair' : route.family)) return false;
    const types = route.formats.length ? route.formats : Object.keys(T).filter(format => T[format].family === (route.family === 'concern' ? 'hair' : route.family));
    return v.formats.some(format => types.includes(format)) && (!route.concerns.length || route.concerns.some(concern => v.concerns.includes(concern)));
  }
  function eligible(v) { return routeEligible(v, selectedRoute()); }
  function inGroup(v) { return state.group === 'all' || (GROUPS[state.group] ? v.formats.some(format => GROUPS[state.group].formats.includes(format)) : v.formats.includes(state.group)); }
  function matches(p, v) {
    return eligible(v) && inGroup(v) && (!state.format || v.formats.includes(state.format)) && (!state.brand || p.vendor === state.brand) && (!state.q || `${p.title} ${p.vendor} ${v.title} ${v.formats.map(format => T[format]?.label || format).join(' ')}`.toLowerCase().includes(state.q.toLowerCase().trim())) && (!state.concern || v.concerns.includes(state.concern)) && (!state.model || v.model === state.model) && (!state.kids || p.kids) && (!state.availability || (state.availability === 'available' ? v.available : state.availability === 'preorder' ? v.available && v.preorder : !v.available)) && (state.min === '' || v.price >= Number(state.min)) && (state.max === '' || v.price <= Number(state.max));
  }
  function results() {
    const out = P.map(p => {
      const variants = p.variants.filter(v => matches(p, v));
      if (!variants.length) return null;
      const available = variants.filter(v => v.available);
      const v = (available.length ? available : variants).reduce((a, b) => a.price <= b.price ? a : b);
      return { p, v };
    }).filter(Boolean);
    if (state.sort === 'price-up') out.sort((a, b) => a.v.price - b.v.price);
    if (state.sort === 'price-down') out.sort((a, b) => b.v.price - a.v.price);
    if (state.sort === 'az') out.sort((a, b) => a.p.title.localeCompare(b.p.title));
    return out;
  }
  function stopNav() { navToken++; destination = ''; cancelAnimationFrame(navFrame); }
  function navigate(id, token = navToken) {
    cancelAnimationFrame(navFrame);
    navFrame = requestAnimationFrame(() => {
      if (token !== navToken) return;
      const element = $(id);
      if (!element) return;
      let bottom = 0;
      document.querySelectorAll('#shopify-section-header,.shopify-section--header,#shopify-section-announcement').forEach(node => {
        const style = getComputedStyle(node), rect = node.getBoundingClientRect();
        if (['fixed', 'sticky'].includes(style.position) && style.display !== 'none' && style.visibility !== 'hidden' && rect.height) bottom = Math.max(bottom, Math.max(0, parseFloat(style.top) || 0) + rect.height);
      });
      if (!element.hasAttribute('tabindex') && !element.matches('a,button,input,select,textarea')) element.tabIndex = -1;
      element.focus({ preventScroll: true });
      window.scrollTo({ top: Math.max(0, window.scrollY + element.getBoundingClientRect().top - bottom - 16), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  }
  function read(initial = false) {
    const locationUrl = new URL(location.href), params = locationUrl.searchParams;
    let category = allRoute.handle;
    if (params.has('hb_category')) category = registry[params.get('hb_category')] ? params.get('hb_category') : allRoute.handle;
    else if (params.has('hb_family')) category = familyHandles[params.get('hb_family')] || allRoute.handle;
    else category = registry[pathHandle(locationUrl.pathname)]?.handle || (initial && registry[root.dataset.hbInitialCategory] ? root.dataset.hbInitialCategory : initial && familyHandles[root.dataset.hbInitialPage] ? familyHandles[root.dataset.hbInitialPage] : allRoute.handle);
    const next = blank(category);
    [...fields, 'group'].forEach(key => { if (params.has('hb_' + key)) next[key] = params.get('hb_' + key); });
    if (next.group !== 'all' && !GROUPS[next.group] && !T[next.group]) next.group = 'all';
    if (next.format && !T[next.format]) next.format = '';
    if (!['curated', 'price-up', 'price-down', 'az'].includes(next.sort)) next.sort = 'curated';
    if (!['', 'available', 'preorder', 'sold'].includes(next.availability)) next.availability = '';
    for (const key of ['min', 'max']) if (next[key] !== '' && (!Number.isFinite(Number(next[key])) || Number(next[key]) < 0)) next[key] = '';
    if (!['', 'kids'].includes(next.kids)) next.kids = '';
    return next;
  }
  function save() {
    const next = new URL(location.href);
    if (nativePage === 1) next.pathname = url(root.dataset.sourceUrl).pathname;
    if (state.category !== allRoute.handle) next.searchParams.set('hb_category', state.category);
    else next.searchParams.delete('hb_category');
    next.searchParams.delete('hb_family');
    for (const key of [...fields, 'group']) {
      if (state[key] && state[key] !== blank()[key]) next.searchParams.set('hb_' + key, state[key]);
      else next.searchParams.delete('hb_' + key);
    }
    if (nativePage > 1) next.searchParams.set('page', String(nativePage));
    else next.searchParams.delete('page');
    history[historyMode === 'push' ? 'pushState' : 'replaceState'](null, '', next.pathname + next.search + next.hash);
    historyMode = 'replace';
  }
  function setText(id, value) { const node = $(id); if (node) node.textContent = value || ''; }
  function syncFamily() {
    if (categoryKey === state.category) return;
    categoryKey = state.category;
    const route = selectedRoute(), profile = copy[route.handle];
    root.dataset.hbPage = route.family;
    root.dataset.hbFamily = route.family;
    root.dataset.hbCategory = route.handle;
    $('hero').dataset.tone = route.family;
    setText('hero-kicker', profile.label || route.label);
    $('hero-title').replaceChildren(...profile.title.map(text => { const span = document.createElement('span'); span.textContent = text; return span; }));
    setText('hero-intro', profile.intro);
    const art = artwork.get(route.handle)?.content;
    if (art) $('hero-art').replaceChildren(...[...art.childNodes].map(node => node.cloneNode(true)));
    setText('crumb-current', route.handle === allRoute.handle ? '' : '› ' + route.label);
    setText('results-title', profile.productsHeading || resultHeading);
    setText('faq-title', profile.faqHeading || route.label + ' questions, answered');
    if ($('faq-intro')) setText('faq-intro', profile.faqIntro || 'A little guidance for choosing your next everyday favourite.');
    $('faq-list').innerHTML = profile.faq.map(item => `<details><summary>${esc(item.q)}</summary><p>${esc(item.a)}</p></details>`).join('');
    setText('seo-title', profile.seoTitle);
    setText('seo-intro', profile.seoIntro);
    if ($('seo-articles')) $('seo-articles').innerHTML = profile.articles.map((item, index) => `<article><div class="num">${String(index + 1).padStart(2, '0')}</div><h3>${esc(item.title)}</h3><p>${esc(item.text)}</p></article>`).join('');
    const parent = familyRoute(route), children = routes.filter(item => item.kind !== 'family' && item.parent === parent.handle);
    const relatedParent = route.kind === 'family' ? allRoute : parent;
    const related = [...new Map([relatedParent, ...routes.filter(item => item.kind === route.kind && item.parent === route.parent && item.handle !== route.handle)].filter(item => item.handle !== route.handle).map(item => [item.handle, item])).values()].slice(0, 4);
    if (route.handle === allRoute.handle) related.push(...familyRoutes.filter(item => item.handle !== allRoute.handle).slice(0, 4));
    if ($('related-links')) $('related-links').innerHTML = related.map(item => `<a data-hb-category="${esc(item.handle)}" href="${esc(routeHref(item.handle))}">${esc(item.label)}</a>`).join('');
    setText('selection-line', route.kind === 'family' ? route.label : parent.label + ' / ' + route.label);
    if ($('selection-line')) $('selection-line').hidden = route.handle === allRoute.handle;
    const section = $('pills').closest('.pill-section'), concernView = route.family === 'concern';
    if (section) section.hidden = route.handle === allRoute.handle;
    const eyebrow = section?.querySelector('.section-kicker');
    if (eyebrow) eyebrow.textContent = concernView ? D.ui?.concernKicker || originalPillLabels.kicker : originalPillLabels.kicker;
    $('pills').setAttribute('aria-label', concernView ? D.ui?.concernGroupLabel || originalOptions.concern : originalPillLabels.group);
    setText('pill-title', route.family === 'concern' ? 'Choose your hair concern' : 'Explore ' + parent.label);
    $('pills').innerHTML = route.handle === allRoute.handle ? '' : [parent, ...children].map(item => `<a class="pill" data-hb-category="${esc(item.handle)}" href="${esc(routeHref(item.handle))}" aria-pressed="${item.handle === route.handle}">${esc(item.handle === parent.handle ? concernView ? originalOptions.concern : 'All ' + parent.label : item.label)}<span class="pill-count"></span></a>`).join('');
    prepareFamilyLinks();
  }
  function buildNavigation() {
    $('family-nav').innerHTML = familyRoutes.map(route => `<a class="family-link" data-hb-category="${esc(route.handle)}" href="${esc(routeHref(route.handle))}">${esc(route.label)}<span class="family-count pill-count"></span></a>`).join('');
    const directory = $('directory');
    if (directory) directory.innerHTML = familyRoutes.filter(route => route.handle !== allRoute.handle).map(route => `<div><h3><a data-hb-category="${esc(route.handle)}" href="${esc(routeHref(route.handle))}">${esc(route.label)}</a></h3>${routes.filter(child => child.kind !== 'family' && child.parent === route.handle).map(child => `<a data-hb-category="${esc(child.handle)}" href="${esc(routeHref(child.handle))}">${esc(child.label)}</a>`).join('')}</div>`).join('');
  }
  function revealPill(button) {
    const rail = button?.parentElement;
    if (!rail || rail.scrollWidth <= rail.clientWidth) return;
    const buttonRect = button.getBoundingClientRect(), railRect = rail.getBoundingClientRect();
    rail.scrollLeft += buttonRect.left < railRect.left ? buttonRect.left - railRect.left - 4 : buttonRect.right > railRect.right ? buttonRect.right - railRect.right + 4 : 0;
  }
  function renderPills() {
    const parent = familyRoute(), counts = new Map();
    const count = handle => { if (!counts.has(handle)) counts.set(handle, P.filter(p => p.variants.some(v => routeEligible(v, registry[handle]))).length); return counts.get(handle); };
    for (const link of root.querySelectorAll('#hb-pills [data-hb-category],#hb-family-nav [data-hb-category]')) {
      const handle = link.dataset.hbCategory, inFamily = link.closest('#hb-family-nav'), active = handle === (inFamily ? parent.handle : state.category);
      link.setAttribute('aria-pressed', String(active));
      if (active) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
      const counter = link.querySelector('.pill-count');
      if (counter) counter.textContent = loaded ? String(count(handle)) : '';
      link.hidden = false;
    }
    revealPill($('pills').querySelector('[aria-pressed="true"]'));
    revealPill($('family-nav').querySelector('[aria-current="page"]'));
  }
  function renderOptions() {
    if (!loaded) { fields.forEach(key => { $(key).value = state[key]; }); return; }
    const pool = P.map(p => ({ p, variants: p.variants.filter(v => eligible(v) && inGroup(v)) })).filter(row => row.variants.length);
    const route = selectedRoute(), allowed = route.formats;
    const formats = Object.keys(T).filter(format => (route.handle === allRoute.handle || !allowed.length || allowed.includes(format)) && pool.some(row => row.variants.some(v => v.formats.includes(format))));
    $('format').innerHTML = '<option value="">' + esc(originalOptions.format) + '</option>' + formats.map(key => `<option value="${esc(key)}">${esc(T[key].label)}</option>`).join('');
    $('brand').innerHTML = '<option value="">' + esc(originalOptions.brand) + '</option>' + [...new Set(pool.map(row => row.p.vendor))].sort().map(value => `<option>${esc(value)}</option>`).join('');
    for (const key of ['format', 'brand']) if (state[key] && ![...$(key).options].some(option => option.value === state[key])) state[key] = '';
    for (const [id, property] of [['concern', 'concerns'], ['model', 'model']]) {
      const values = [...new Set(pool.flatMap(row => row.variants.flatMap(v => Array.isArray(v[property]) ? v[property] : [v[property]])).filter(Boolean))];
      const label = value => D[id + 's']?.[value]?.label || D[id + 's']?.[value] || originalLabels[id][value] || value.replaceAll('-', ' ').replace(/^./, c => c.toUpperCase());
      values.sort((a, b) => String(label(a)).localeCompare(String(label(b))));
      $(id).innerHTML = `<option value="">${esc(originalOptions[id])}</option>` + values.map(value => `<option value="${esc(value)}">${esc(label(value))}</option>`).join('');
      if (state[id] && !values.includes(state[id])) state[id] = '';
      $(id + '-field').hidden = !values.length;
    }
    const hasKids = pool.some(row => row.p.kids);
    $('family-field').hidden = !hasKids;
    if (!hasKids) state.kids = '';
    fields.forEach(key => { $(key).value = state[key]; });
  }
  function renderGuide() {
    const profile = copy[state.category], guide = state.format ? G[state.format] : null;
    setText('guide-label', guide ? T[state.format].label : profile.label);
    setText('guide-title', guide ? guide[0] : profile.guideTitle);
    setText('guide-description', guide ? guide[1] : profile.description);
    setText('guide-choose', profile.choose);
    setText('guide-compare', guide ? guide[2] : profile.compare);
    setText('guide-how', guide ? guide[3] : profile.how);
  }
  function renderChips() {
    const labels = { q: 'Search', format: 'Type', brand: 'Brand', availability: 'Availability', min: 'Min S$', max: 'Max S$', concern: 'Concern', model: 'Shower range', kids: 'Family' };
    const chips = Object.keys(labels).filter(key => state[key]).map(key => {
      const field = $(key), value = field.tagName === 'SELECT' ? field.options[field.selectedIndex]?.text : state[key];
      return `<button type="button" class="chip" data-remove="${key}">${esc(labels[key])}: ${esc(value)} ×</button>`;
    });
    if (state.group !== 'all') chips.unshift(`<button type="button" class="chip" data-remove="group">${esc(GROUPS[state.group]?.label || T[state.group]?.label || state.group)} ×</button>`);
    $('selections').hidden = !chips.length;
    $('selections').innerHTML = chips.length ? chips.join('') + '<button type="button" class="clear" data-clear>Clear all</button>' : '';
  }
  function priceValid() {
    const min = $('min').value, max = $('max').value;
    const valid = !(min !== '' && (!Number.isFinite(Number(min)) || Number(min) < 0)) && !(max !== '' && (!Number.isFinite(Number(max)) || Number(max) < 0)) && !(min !== '' && max !== '' && Number(min) > Number(max));
    $('price-error').hidden = valid;
    for (const key of ['min', 'max']) $(key).setAttribute('aria-invalid', String(!valid));
    return valid;
  }
  function status(key) {
    $('status').hidden = !key;
    $('status-text').textContent = key === 'error' ? 'We couldn’t load these products. Please try again.' : key === 'loading' ? 'Loading the latest products…' : '';
    $('retry').hidden = key !== 'error';
  }
  async function json(target) {
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetch(target, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } });
      if (!response.ok) throw Error('Storefront request failed');
      return JSON.parse(await response.text());
    } finally { clearTimeout(timeout); }
  }
  function cacheCards(batch, result) {
    if (!Array.isArray(result?.items)) return;
    const expected = new Set(batch.map(p => p.id)), counts = new Map();
    result.items.forEach(item => { if (item && typeof item.id === 'string') counts.set(item.id, (counts.get(item.id) || 0) + 1); });
    for (const item of result.items) {
      if (!item || !expected.has(item.id) || counts.get(item.id) !== 1 || typeof item.html !== 'string') continue;
      const template = document.createElement('template'); template.innerHTML = item.html;
      template.content.querySelectorAll('script:not([type="application/json"])').forEach(node => node.remove());
      const card = template.content.firstElementChild;
      if (template.content.children.length !== 1 || !card?.matches('article[data-hair-body-product]') || card.dataset.hairBodyProduct !== item.id) continue;
      cards.set(item.id, card);
    }
  }
  async function fetchCards(batch) {
    const request = async group => {
      const target = url(root.dataset.searchUrl);
      target.searchParams.set('view', 'cocomo-hair-body-cards'); target.searchParams.set('type', 'product'); target.searchParams.set('q', group.map(p => p.handle).join(','));
      cacheCards(group, await json(target));
    };
    try { await request(batch); } catch (_) { /* Retry only missing native cards below. */ }
    const missing = batch.filter(p => !cards.has(p.id)); let cursor = 0;
    const workers = Array.from({ length: Math.min(3, missing.length) }, async () => {
      while (cursor < missing.length) {
        const product = missing[cursor++]; await request([product]);
        if (!cards.has(product.id)) throw Error('Missing product card');
      }
    });
    const settled = await Promise.allSettled(workers), failure = settled.find(item => item.status === 'rejected');
    if (failure) throw failure.reason;
    if (batch.some(p => !cards.has(p.id))) throw Error('Missing product cards');
  }
  async function ensure(rows) {
    const missing = rows.map(row => row.p).filter(p => !cards.has(p.id) && !pending.has(p.id));
    for (let index = 0; index < missing.length; index += 12) {
      const batch = missing.slice(index, index + 12), job = fetchCards(batch).finally(() => batch.forEach(p => pending.delete(p.id)));
      batch.forEach(p => pending.set(p.id, job));
    }
    await Promise.all(rows.filter(row => !cards.has(row.p.id)).map(row => pending.get(row.p.id)));
  }
  function applyVariant(card, p, v) {
    const target = url(p.url); target.searchParams.set('variant', v.id);
    card.querySelectorAll('.ProductItem__ImageWrapper,.ProductItem__Title>a,.ch-card-extra>a').forEach(link => { link.href = target.pathname + target.search; });
    card.querySelector('.ProductItem__ImageWrapper')?.classList.remove('ProductItem__ImageWrapper--withAlternateImage');
    const price = card.querySelector('.ProductItem__PriceList');
    if (price) {
      price.replaceChildren(); const main = document.createElement('span'); main.className = 'ProductItem__Price Price Text--subdued'; main.textContent = decode(v.money); price.append(main);
      if (v.compare > v.price) { const compare = document.createElement('span'); compare.className = 'ProductItem__Price Price Price--compareAt Text--subdued'; compare.textContent = decode(v.compare_money); price.append(compare); }
    }
    let top = card.querySelector('.CocomoCollectionCard__TopBadges');
    if (!top) { const media = card.querySelector('.CocomoCollectionCard__Media'); if (media) { top = document.createElement('div'); top.className = 'CocomoCollectionCard__TopBadges'; media.prepend(top); } }
    if (top) {
      top.querySelectorAll('.CocomoCollectionCard__Badge--saving,.CocomoCollectionCard__Badge--soldOut').forEach(badge => badge.remove());
      let type = top.querySelector('.CocomoCollectionCard__Badge--type');
      if (!type) { type = document.createElement('span'); type.className = 'CocomoCollectionCard__Badge CocomoCollectionCard__Badge--type'; top.prepend(type); }
      const key = state.format && v.formats.includes(state.format) ? state.format : selectedRoute().formats.find(format => v.formats.includes(format)) || v.formats.find(format => state.page === 'all' || T[format]?.family === pageFamily()) || v.formats[0];
      type.textContent = D.badges[key] || T[key]?.label || 'Hair & body';
      if (!v.available || v.compare > v.price) { const badge = document.createElement('span'); badge.className = 'CocomoCollectionCard__Badge CocomoCollectionCard__Badge--' + (!v.available ? 'soldOut' : 'saving'); badge.textContent = !v.available ? 'Sold out' : 'SAVE ' + Math.round((v.compare - v.price) / v.compare * 100) + '%'; top.append(badge); }
    }
    card.dataset.hbSelected = v.id; card.dataset.hbInstallment = decode(v.installment_money);
  }
  const originalMinimums = new WeakMap();
  function alignRows() {
    const grid = $('grid');
    if (grid.hidden || !grid.getBoundingClientRect().width) return;
    const selectors = ['.CocomoCollectionCard__Media', '.CocomoCollectionCard__Flair', '.ProductItem__Title', '.ProductItem__PriceList'];
    const entries = [...grid.querySelectorAll('.ch-card[data-hair-body-product]')].map(card => ({ card, parts: selectors.map(selector => card.querySelector(selector)) }));
    entries.forEach(entry => entry.parts.forEach(node => {
      if (!node) return;
      if (!originalMinimums.has(node)) originalMinimums.set(node, [node.style.getPropertyValue('min-height'), node.style.getPropertyPriority('min-height')]);
      const [value, priority] = originalMinimums.get(node);
      if (value) node.style.setProperty('min-height', value, priority); else node.style.removeProperty('min-height');
    }));
    const rows = [];
    entries.forEach(entry => {
      const top = entry.card.getBoundingClientRect().top;
      let row = rows.find(item => Math.abs(item.top - top) < 2);
      if (!row) { row = { top, entries: [] }; rows.push(row); }
      row.entries.push(entry);
    });
    rows.forEach(row => selectors.forEach((_, index) => {
      const nodes = row.entries.map(entry => entry.parts[index]).filter(Boolean);
      const height = Math.ceil(Math.max(0, ...nodes.map(node => node.getBoundingClientRect().height)));
      nodes.forEach(node => { node.style.minHeight = height + 'px'; });
    }));
  }
  let installmentFrame = 0;
  function syncInstallments() {
    if (installmentFrame) return;
    installmentFrame = requestAnimationFrame(() => {
      installmentFrame = 0;
      root.querySelectorAll('[data-hb-installment]').forEach(card => card.querySelectorAll('.atome-price-divider .atome-price').forEach(node => { if (node.textContent !== card.dataset.hbInstallment) node.textContent = card.dataset.hbInstallment; }));
      alignRows();
    });
  }
  function updateCounts(visibleCount) {
    $('result-count').textContent = `${current.length} matching product${current.length === 1 ? '' : 's'}`;
    $('guide-count').textContent = `${current.length} matching product${current.length === 1 ? '' : 's'} to explore`;
    $('shown-count').textContent = `Showing ${Math.min(visibleCount, current.length)} of ${current.length} product${current.length === 1 ? '' : 's'}`;
  }
  async function render(append = false) {
    const token = ++version, nav = navToken;
    syncFamily(); renderOptions(); renderGuide(); renderPills(); renderChips(); save(); priceValid();
    if (destination === 'guide') { navigate('guide', nav); destination = ''; }
    if (!loaded) {
      $('show-more').hidden = true; $('show-more').disabled = true;
      if (state.category !== allRoute.handle || state.group !== 'all' || fields.some(key => state[key] !== blank()[key])) $('grid').hidden = true;
      return;
    }
    current = results(); const rows = current.slice(0, shown);
    $('grid').setAttribute('aria-busy', 'true'); $('show-more').disabled = true;
    if (!append) $('show-more').hidden = true;
    const needs = rows.some(row => !cards.has(row.p.id));
    if (needs && !append) $('grid').hidden = true;
    status(needs ? 'loading' : '');
    if (needs) $('result-count').textContent = $('status-text').textContent;
    try {
      await ensure(rows);
      if (token !== version) return;
      const nodes = rows.map(({ p, v }) => { const card = cards.get(p.id); applyVariant(card, p, v); return card; });
      if (append) {
        const present = new Set([...$('grid').querySelectorAll('[data-hair-body-product]')].map(card => card.dataset.hairBodyProduct));
        nodes.filter(card => !present.has(card.dataset.hairBodyProduct)).forEach(card => $('grid').append(card));
      } else $('grid').replaceChildren(...nodes);
      if (!nodes.length) {
        const route = selectedRoute(), parent = familyRoute(), broader = route.kind === 'family' ? allRoute : parent;
        const unfilteredCount = P.filter(p => p.variants.some(v => routeEligible(v, route))).length;
        $('grid').innerHTML = `<div class="empty"><h3>${unfilteredCount ? 'Let’s find a better match.' : 'There are no products in this selection right now.'}</h3><p>${unfilteredCount ? 'Try removing a filter or broadening your search.' : 'Explore the wider collection while you find your next everyday favourite.'}</p>${unfilteredCount ? '<button type="button" class="yellow" data-clear>Clear filters</button>' : ''}${broader.handle !== route.handle ? `<a class="yellow" data-hb-category="${esc(broader.handle)}" data-hb-destination="results" href="${esc(routeHref(broader.handle))}">Browse ${esc(broader.label)}</a>` : ''}</div>`;
      }
      $('grid').hidden = false; updateCounts(nodes.length);
      $('show-more').hidden = nodes.length >= current.length;
      status(''); syncInstallments();
      if ($('native-pagination')) $('native-pagination').hidden = true;
      if (destination && nav === navToken) { navigate(destination, nav); destination = ''; }
    } catch (_) {
      if (token === version) {
        if (!append) { $('grid').hidden = true; $('show-more').hidden = true; }
        updateCounts(append ? $('grid').querySelectorAll('[data-hair-body-product]').length : 0);
        status('error');
        if ($('native-pagination')) $('native-pagination').hidden = false;
        if (destination && nav === navToken) { navigate(destination, nav); destination = ''; }
      }
    } finally {
      if (token === version) { $('grid').setAttribute('aria-busy', 'false'); $('show-more').disabled = false; }
    }
  }
  function commit(dest = null) {
    clearTimeout(timer);
    if (!priceValid()) return;
    stopNav(); fields.forEach(key => { state[key] = $(key).value; });
    nativePage = 1; shown = 12; destination = dest; render();
  }
  function refresh(dest = null) { clearTimeout(timer); stopNav(); nativePage = 1; shown = 12; destination = dest; render(); }
  function chooseCategory(category, dest = 'guide') {
    if (!registry[category]) return;
    const sort = state.sort;
    historyMode = category !== state.category ? 'push' : 'replace';
    state = blank(category);
    if (category !== allRoute.handle) state.sort = sort;
    refresh(dest);
  }
  async function load() {
    status('loading'); $('show-more').hidden = true; $('show-more').disabled = true;
    try {
      const target = url(root.dataset.sourceUrl); target.searchParams.set('view', 'cocomo-hair-body-index'); target.searchParams.set('page', '1'); target.searchParams.set('sort_by', 'manual');
      const first = await json(target);
      if (first.page !== 1 || !Array.isArray(first.items) || !Number.isInteger(first.pages) || first.pages < 1 || first.pages > 80 || new URL(first.collection, location.origin).pathname !== new URL(root.dataset.sourceUrl, location.origin).pathname) throw Error('Invalid catalog');
      const items = [...first.items];
      for (let page = 2; page <= first.pages; page++) {
        target.searchParams.set('page', String(page)); const next = await json(target);
        if (next.page !== page || next.total !== first.total || next.pages !== first.pages || !Array.isArray(next.items)) throw Error('Incomplete catalog');
        items.push(...next.items);
      }
      if (items.length !== first.total || new Set(items.map(p => p.id)).size !== items.length) throw Error('Incomplete catalog');
      P = [...new Map([...items, ...(first.extras || [])].map(p => [p.id, p])).values()].filter(p => p.variants?.length).map(p => ({ ...p, variants: p.variants.filter(v => Array.isArray(v.formats) && v.formats.length && v.formats.every(format => T[format])) })).filter(p => p.variants.length).sort((a, b) => a.index - b.index);
      if (P.some(p => !/^\d+$/.test(p.id) || typeof p.handle !== 'string' || /[,/?#\\\u0000-\u001f]/.test(p.handle) || p.variants.some(v => !/^\d+$/.test(v.id) || !Number.isFinite(v.price) || typeof v.available !== 'boolean' || !Array.isArray(v.concerns)))) throw Error('Invalid variant');
      loaded = true; root.dataset.hbLoaded = String(P.length); await render();
    } catch (_) { status('error'); if ($('native-pagination')) $('native-pagination').hidden = false; }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0 || link.target === '_blank' || link.hasAttribute('download') || link.getAttribute('href').startsWith('#')) return;
    const route = routeForLink(link);
    if (!route) return;
    event.preventDefault();
    const panel = link.closest('.cmp-panel');
    if (panel && !panel.hidden) panel.querySelector('[data-cmp-close]')?.click();
    const drawer = link.closest('#sidebar-menu');
    if (drawer?.getAttribute('aria-hidden') === 'false') drawer.querySelector('[data-action="close-drawer"][data-drawer-id="sidebar-menu"]')?.click();
    const inPills = link.closest('#hb-family-nav,#hb-pills');
    chooseCategory(route.handle, link.dataset.hbDestination || (inPills ? 'guide' : 'hero'));
  });
  root.addEventListener('click', event => {
    const scroll = event.target.closest('[data-scroll]');
    if (scroll) { clearTimeout(timer); stopNav(); navigate(scroll.dataset.scroll); return; }
    const remove = event.target.closest('[data-remove]');
    if (remove) { const key = remove.dataset.remove; state[key] = key === 'group' ? 'all' : ''; if ($(key)) $(key).value = ''; refresh('results'); return; }
    if (event.target.closest('[data-clear]')) { state = blank(state.category); refresh('results'); return; }
    if (event.target.closest('#hb-retry')) { clearTimeout(timer); loaded ? render() : load(); }
  });
  fields.forEach(key => {
    $(key).addEventListener('change', () => commit(['q', 'min', 'max'].includes(key) ? null : 'results'));
    if (['q', 'min', 'max'].includes(key)) {
      $(key).addEventListener('input', () => { clearTimeout(timer); stopNav(); timer = setTimeout(() => commit(null), 180); });
      $(key).addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); commit('results'); } });
    }
  });
  $('filter-form').addEventListener('submit', event => { event.preventDefault(); commit('results'); });
  $('filter-form').addEventListener('reset', event => { event.preventDefault(); state = blank(state.category); refresh('results'); });
  $('show-more').addEventListener('click', () => {
    if (!loaded || $('show-more').disabled) return;
    clearTimeout(timer); stopNav(); shown = $('grid').querySelectorAll('[data-hair-body-product]').length + 12; render(true);
  });
  window.addEventListener('popstate', () => { clearTimeout(timer); stopNav(); historyMode = 'replace'; state = read(); nativePage = readNativePage(); shown = nativePage * 12; render(); });
  ['wheel', 'touchmove'].forEach(event => window.addEventListener(event, stopNav, { passive: true }));
  new MutationObserver(syncInstallments).observe($('grid'), { childList: true, subtree: true, characterData: true });
  $('grid').addEventListener('load', syncInstallments, true);
  let gridWidth = 0;
  if (typeof ResizeObserver === 'function') new ResizeObserver(entries => {
    const width = entries[0]?.contentRect.width || 0;
    if (Math.abs(width - gridWidth) > 0.5) { gridWidth = width; syncInstallments(); }
  }).observe($('grid'));
  window.addEventListener('resize', syncInstallments);
  document.fonts?.ready.then(syncInstallments);
  state = read(true); buildNavigation(); prepareFamilyLinks(); render(); load();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cocomo-step-shared"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if(window.CocomoSkincareSteps){window.CocomoSkincareSteps.mountWithin(document);return;}
  function createController({prefix,formatKeys,catalogueView,shoppingId}) {
  const mounted = new WeakMap();
  const PAGE_SIZE = 12;
  const formats = new Set(formatKeys);
  const sorts = new Set(['featured', 'price-asc', 'price-desc', 'title']);
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim().replace(/\s+/g, ' ');

  function preservePreviewLinks(root) {
    const current = new URL(window.location.href);
    if (!current.searchParams.has('preview_theme_id')) return;
    root.querySelectorAll('a[href]').forEach(anchor => {
      const raw = anchor.getAttribute('href');
      if (!raw || raw.startsWith('#')) return;
      let target;
      try { target = new URL(raw, current); } catch (_) { return; }
      if (target.origin !== current.origin || !/^https?:$/.test(target.protocol)) return;
      ['preview_theme_id', '_fd', 'pb'].forEach(key => {
        if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
      });
      const href = target.pathname + target.search + target.hash;
      if (raw !== href) anchor.setAttribute('href', href);
    });
  }

  async function loadCompleteCatalogue(root, existingCards, expectedTotal, signal, abort) {
    const current = new URL(window.location.href);
    const base = new URL(root.dataset.collectionUrl, current);
    if (base.origin !== current.origin || !/^https?:$/.test(base.protocol)) throw new Error('Invalid collection origin');
    const collectionPath = base.pathname.replace(/\/$/, '');
    const expectedPages = Math.ceil(expectedTotal / 250);
    const pageResults = new Array(expectedPages);
    async function fetchPage(page) {
      const url = new URL(base);
      url.search = '';
      url.hash = '';
      url.searchParams.set('view', catalogueView);
      url.searchParams.set('page', String(page));
      url.searchParams.set('sort_by', 'manual');
      ['preview_theme_id', '_fd', 'pb'].forEach(key => {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      });
      const timeout = window.setTimeout(abort, 20000);
      try {
        const response = await fetch(url, { credentials: 'same-origin', signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Catalogue response failed');
        const data = JSON.parse(await response.text());
        if (signal.aborted) throw new Error('Catalogue request stopped');
        const actual = new URL(data.collection, current);
        if (actual.origin !== current.origin || actual.pathname.replace(/\/$/, '') !== collectionPath ||
            data.total !== expectedTotal || !Number.isSafeInteger(data.pages) || data.pages !== expectedPages || !Array.isArray(data.items)) throw new Error('Catalogue metadata mismatch');
        const expectedItems = Math.min(250, expectedTotal - (page - 1) * 250);
        if (data.items.length !== expectedItems) throw new Error('Incomplete catalogue page');
        pageResults[page - 1] = data.items;
      } finally { window.clearTimeout(timeout); }
    }
    // Two bounded workers load every page before any partial filter is enabled.
    let nextPage = 1;
    await Promise.all(Array.from({ length: Math.min(2, expectedPages) }, async () => {
      while (nextPage <= expectedPages) {
        if (signal.aborted) throw new Error('Catalogue request stopped');
        await fetchPage(nextPage++);
      }
    }));
    const items = pageResults.flat();
    const ids = new Set(items.map(item => item.id));
    if (items.length !== expectedTotal || ids.size !== expectedTotal || items.some(item => typeof item.id !== 'string' || !item.id || typeof item.html !== 'string')) throw new Error('Catalogue ID mismatch');
    const originals = new Map(existingCards.map(card => [card.dataset[prefix + 'Product'], card]));
    if ([...originals.keys()].some(id => !ids.has(id))) throw new Error('Server card missing from catalogue');
    const cards = items.map(item => {
      const existing = originals.get(item.id);
      if (existing) return existing;
      // Only detached new cards are parsed. Existing server card nodes and app listeners survive.
      const template = document.createElement('template');
      template.innerHTML = item.html;
      template.content.querySelectorAll('script').forEach(node => node.remove());
      const card = template.content.firstElementChild;
      if (template.content.children.length !== 1 || !card?.matches(`article.ch-card[data-${prefix}-product]`) || card.dataset[prefix + 'Product'] !== item.id) throw new Error('Invalid catalogue card');
      return card;
    });
    if (signal.aborted) throw new Error('Catalogue request stopped');
    return cards;
  }

  function mount(root, completeCards = null) {
    if (mounted.has(root)) return;
    const grid = root.querySelector(`[data-${prefix}-grid]`);
    const form = root.querySelector(`[data-${prefix}-form]`);
    const controls = root.querySelector(`[data-${prefix}-controls]`);
    const pagination = root.querySelector(`[data-${prefix}-pagination]`);
    const more = root.querySelector(`[data-${prefix}-more]`);
    const count = root.querySelector(`[data-${prefix}-count]`);
    const empty = root.querySelector(`[data-${prefix}-empty]`);
    preservePreviewLinks(root);
    const routineScroll=root.querySelector('.cs-routine-scroll');
    const currentStep=routineScroll?.querySelector('[aria-current=page]');
    if(currentStep&&routineScroll.scrollWidth>routineScroll.clientWidth){const item=currentStep.getBoundingClientRect(),row=routineScroll.getBoundingClientRect();routineScroll.scrollLeft+=item.left-row.left-(row.width-item.width)/2;}
    if (!grid || !form || !controls || !more || !count || !empty) return;
    const cards = completeCards || [...grid.children].filter(node => node.matches(`article.ch-card[data-${prefix}-product]`));
    const total = Number(root.dataset.total);
    const next = pagination && pagination.querySelector(`a[rel~="next"], [data-${prefix}-next], a.Pagination__NavItem--next`);
    const unique = new Set(cards.map(card => card.dataset[prefix + 'Product'])).size === cards.length;
    const complete = Number.isSafeInteger(total) && total >= 0 && cards.length === total && unique && (!next || completeCards);
    if (!complete) {
      controls.hidden = true;
      more.hidden = true;
      empty.hidden = true;
      if (pagination) pagination.hidden = false;
      cards.forEach(card => { card.hidden = false; });
      root.dataset[prefix + 'Mode'] = 'native';
      if (Number.isSafeInteger(total) && total > 250 && total <= 20000 && cards.length > 0 && cards.length <= 250 && unique && root.dataset.collectionUrl && typeof AbortController === 'function') {
        const controller = new AbortController();
        let canceled = false;
        const abort = () => controller.abort();
        const cleanup = () => {
          canceled = true;
          abort();
          mounted.delete(root);
          root.dataset[prefix + 'Mode'] = 'native';
        };
        mounted.set(root, cleanup);
        root.dataset[prefix + 'Mode'] = 'loading';
        loadCompleteCatalogue(root, cards, total, controller.signal, abort).then(allCards => {
          if (canceled || !root.isConnected) return;
          mounted.delete(root);
          root.dataset[prefix + 'Mode'] = 'native';
          mount(root, allCards);
        }).catch(() => {
          abort();
          if (canceled) return;
          mounted.delete(root);
          root.dataset[prefix + 'Mode'] = 'native';
          // The server cards, count and pagination remain intact and usable.
        });
      }
      return;
    }
    let text = {};
    try { text = JSON.parse(root.querySelector(`[data-${prefix}-i18n]`)?.textContent || '{}'); } catch (_) { return; }
    const formatText = (key, values) => String(text[key] || (key === 'showing' ? 'Showing {shown} of {total} products' : '')).replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
    const records = cards.map((card, rank) => ({
      card, rank,
      formats: (card.dataset.format || '').split(/\s+/).filter(Boolean),
      vendor: card.dataset.vendor || '',
      search: normalize(card.dataset.search || card.querySelector('.ProductItem__Title')?.textContent),
      title: normalize(card.querySelector('.ProductItem__Title>a')?.textContent || card.dataset.search),
      available: card.dataset.available === 'true',
      price: Number.isFinite(Number(card.dataset.price)) ? Number(card.dataset.price) : Infinity
    }));
    if (completeCards) {
      const brandControl = form.elements.namedItem('brand');
      if (brandControl?.options) {
        const existingBrands = new Set([...brandControl.options].map(option => option.value));
        [...new Set(records.map(record => record.vendor).filter(Boolean))].sort((a, b) => a.localeCompare(b)).forEach(brand => {
          if (!existingBrands.has(brand)) brandControl.add(new Option(brand, brand));
        });
      }
    }
    const listeners = [];
    const on = (target, event, handler, options) => {
      target.addEventListener(event, handler, options);
      listeners.push(() => target.removeEventListener(event, handler, options));
    };
    let state = { q: '', brand: '', format: 'all', sort: 'featured' };
    let visible = PAGE_SIZE;
    let timer = 0;
    let frame = 0;
    let stopped = false;
    let aligned = [];
    let displayedCards = [];
    let matchingKey = null;
    let matchingRecords = [];
    const selectors = [
      '.CocomoCollectionCard__TopBadges', '.CocomoCollectionCard__Media',
      '.CocomoCollectionCard__Flair', '.ProductItem__Title>a',
      '.opinew-stars-plugin-product-list', '.ProductItem__PriceList', `.${prefix}-variant-note`
    ];

    function formatOfferPairs() {
      displayedCards.flatMap(card => [...card.querySelectorAll('.CocomoCollectionCard__Flair .flair-badge>div')]).forEach(label => {
        if (label.querySelector('.ch-offer-line')) return;
        const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          const parts = node.textContent.match(/^(\s*ANY\s+\d+\s*\+\s*\d+(?:\.\d+)?%\s*OFF)(\s*,\s*)(ANY\s+\d+\s*\+\s*\d+(?:\.\d+)?%\s*OFF\s*)$/i);
          if (!parts) continue;
          const fragment = document.createDocumentFragment();
          for (let index = 1; index <= 3; index++) {
            const span = document.createElement('span');
            span.className = index === 2 ? 'ch-offer-separator' : 'ch-offer-line';
            span.textContent = parts[index];
            fragment.append(span);
          }
          node.replaceWith(fragment);
          break;
        }
      });
    }
    function alignRows() {
      frame = 0;
      if (stopped || !root.isConnected) return;
      formatOfferPairs();
      observer.takeRecords();
      aligned.forEach(node => node.style.removeProperty('--ch-row-height'));
      aligned = [];
      if (!grid.getBoundingClientRect().width) return;
      const rows = [];
      displayedCards.forEach(card => {
        if (card.hidden || !card.getClientRects().length) return;
        const top = card.getBoundingClientRect().top;
        let row = rows.find(item => Math.abs(item.top - top) < 2);
        if (!row) { row = { top, cards: [] }; rows.push(row); }
        row.cards.push(card);
      });
      const measured = selectors.flatMap(selector => rows.map(row => {
        const nodes = row.cards.map(card => card.querySelector(selector)).filter(Boolean);
        const height = Math.ceil(Math.max(0, ...nodes.map(node => node.getBoundingClientRect().height)));
        return { nodes, height };
      }));
      measured.forEach(({ nodes, height }) => {
        if (height <= 0) return;
        nodes.forEach(node => {
          node.style.setProperty('--ch-row-height', height + 'px');
          aligned.push(node);
        });
      });
    }
    function scheduleAlignment() {
      if (!stopped && !frame) frame = requestAnimationFrame(alignRows);
    }
    const observer = new MutationObserver(changes => {
      if (changes.some(change => {
        const target = change.target.nodeType === 1 ? change.target : change.target.parentElement;
        const card = target?.closest('.ch-card');
        return !card || !card.hidden;
      })) scheduleAlignment();
    });
    observer.observe(grid, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    let gridWidth = 0;
    const widthObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(entries => {
      const width = entries[0].contentRect.width;
      if (Math.abs(width - gridWidth) > 0.5) { gridWidth = width; scheduleAlignment(); }
    }) : null;
    widthObserver?.observe(grid);
    on(window, 'resize', scheduleAlignment);
    on(grid, 'load', scheduleAlignment, true);
    document.fonts?.ready.then(scheduleAlignment);
    if (document.fonts?.addEventListener) on(document.fonts, 'loadingdone', scheduleAlignment);

    const education=root.querySelector(`[data-${prefix}-education]`);
    const choices=root.querySelector(`[data-${prefix}-choices]`);
    const decode=value=>{const node=document.createElement('textarea');node.innerHTML=String(value);return node.value;};
    const guideData=JSON.parse(root.querySelector(`[data-${prefix}-education-copy]`).textContent);
    const lessons=[...education.querySelectorAll(`[data-${prefix}-lesson]`)];
    education.querySelectorAll(`[data-${prefix}-guide-more]`).forEach(detail=>{detail.open=!window.matchMedia('(max-width:767px)').matches;});
    function updateEducation(total){
      const key=state.format,copy=guideData.panels[key];
      education.dataset.guide=key;education.dataset.tone=copy.tone;
      education.classList.toggle('is-overview',key==='all');
      lessons.forEach(lesson=>{lesson.hidden=lesson.dataset[prefix + 'Lesson']!==key;});
      education.querySelector(`[data-${prefix}-guide-count]`).textContent=total===1?decode(guideData.countOne):decode(guideData.count).replace('__COUNT__',String(total));
      education.querySelector(`[data-${prefix}-guide-cta]`).textContent=decode(copy.cta);
      education.querySelector(`[data-${prefix}-guide-shop]`).setAttribute('aria-disabled',String(total===0));
    }
    function scrollToCleanse(target,focusTarget=target){
      if(!target)return;
      const offset=()=>{
        const header=document.querySelector('#shopify-section-header');
        if(!header)return 16;
        const rect=header.getBoundingClientRect();
        return ['sticky','fixed'].includes(getComputedStyle(header).position)&&rect.bottom>0&&rect.top<innerHeight?Math.max(0,rect.bottom)+16:16;
      };
      focusTarget?.focus?.({preventScroll:true});
      window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-offset()),behavior:'instant'});
      requestAnimationFrame(()=>{if(stopped)return;const remaining=target.getBoundingClientRect().top-offset();if(Math.abs(remaining)>2)window.scrollBy({top:remaining,behavior:'instant'});});
    }
    function returnToCleanseChoices(){
      const row=root.querySelector(`.${prefix}-formats`);
      const selected=[...row.querySelectorAll(`[data-${prefix}-format]`)].find(node=>node.dataset[prefix + 'Format']===state.format);
      if(selected&&row.scrollWidth>row.clientWidth){const item=selected.getBoundingClientRect(),rect=row.getBoundingClientRect();row.scrollTo({left:row.scrollLeft+item.left-rect.left-(row.clientWidth-item.width)/2,behavior:'instant'});}
      scrollToCleanse(row,selected||choices);
    }
    on(root,'click',event=>{
      if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||event.button>0)return;
      const control=event.target.closest?.(`[data-${prefix}-format],a[href]`);
      if(!control||!root.contains(control))return;
      const format=control.dataset[prefix + 'Format'];
      const shop=control.hasAttribute(`data-${prefix}-guide-shop`);
      const back=control.hasAttribute(`data-${prefix}-guide-back`);
      const reset=control.getAttribute('href')==='#' + shoppingId&&!format;
      if(!formats.has(format)&&!shop&&!back&&!reset)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(control.getAttribute('aria-disabled')==='true')return;
      if(back)return returnToCleanseChoices();
      if(shop)return scrollToCleanse(grid);
      if(reset){change({q:'',brand:'',format:'all',sort:'featured'});return scrollToCleanse(choices);}
      change({format});
      scrollToCleanse(format==='all'?choices:education);
    },true);

    function readHash() {
      const query = new URLSearchParams(window.location.hash.slice(1));
      state = {
        q: query.get(`${prefix}-q`) || '', brand: query.get(`${prefix}-brand`) || '',
        format: formats.has(query.get(`${prefix}-format`)) ? query.get(`${prefix}-format`) : 'all',
        sort: sorts.has(query.get(`${prefix}-sort`)) ? query.get(`${prefix}-sort`) : 'featured'
      };
      if (state.brand && !records.some(record => record.vendor === state.brand)) state.brand = '';
    }
    function writeHash(replace) {
      const url = new URL(window.location.href);
      const query = new URLSearchParams(url.hash.slice(1));
      const defaults = { q: '', brand: '', format: 'all', sort: 'featured' };
      Object.keys(state).forEach(key => {
        if (state[key] === defaults[key]) query.delete(`${prefix}-` + key);
        else query.set(`${prefix}-` + key, state[key]);
      });
      url.hash = query.toString();
      if (url.href !== window.location.href) window.history[replace ? 'replaceState' : 'pushState']({}, '', url);
    }
    function syncControls() {
      ['q', 'brand', 'sort'].forEach(key => { const control = form.elements.namedItem(key); if (control) control.value = state[key]; });
      root.querySelectorAll(`[data-${prefix}-format]`).forEach(button => {
        const active = button.dataset[prefix + 'Format'] === state.format;
        if (button.tagName === 'BUTTON') button.setAttribute('aria-pressed', String(active));
        button.classList.toggle('is-active', active);
      });
    }
    function render() {
      if (stopped) return;
      const nextMatchingKey = JSON.stringify([state.q, state.brand, state.format, state.sort]);
      if (nextMatchingKey !== matchingKey) {
        const words = normalize(state.q).split(' ').filter(Boolean);
        matchingRecords = records.filter(record => (state.format === 'all' || record.formats.includes(state.format)) && (!state.brand || record.vendor === state.brand) && words.every(word => record.search.includes(word)));
        matchingRecords.sort((a, b) => {
          if (a.available !== b.available) return Number(b.available) - Number(a.available);
          if (state.sort === 'price-asc') return a.price - b.price || a.rank - b.rank;
          if (state.sort === 'price-desc') return b.price - a.price || a.rank - b.rank;
          if (state.sort === 'title') return a.title.localeCompare(b.title) || a.rank - b.rank;
          return a.rank - b.rank;
        });
        matchingKey = nextMatchingKey;
      }
      const matches = matchingRecords;
      const shown = matches.slice(0, visible);
      const shownSet = new Set(shown.map(record => record.card));
      const matched = new Set(matches);
      const ordered = [...matches, ...records.filter(record => !matched.has(record))];
      displayedCards = shown.map(record => record.card);
      ordered.forEach(record => {
        const hidden = !shownSet.has(record.card);
        if (record.card.hidden !== hidden) record.card.hidden = hidden;
      });
      let cursor = grid.firstElementChild;
      ordered.forEach(record => {
        if (record.card === cursor) cursor = cursor.nextElementSibling;
        else grid.insertBefore(record.card, cursor);
      });
      count.textContent = formatText('showing', { shown: shown.length, total: matches.length });
      empty.hidden = matches.length !== 0;
      more.hidden = shown.length >= matches.length;
      syncControls();
      updateEducation(matches.length);
      preservePreviewLinks(root);
      scheduleAlignment();
    }
    function change(values, replace = false) {
      clearTimeout(timer);
      state = { ...state, q: form.elements.namedItem('q').value, ...values };
      visible = PAGE_SIZE;
      writeHash(replace);
      render();
    }
    on(form, 'submit', event => {
      event.preventDefault();
      const values = Object.fromEntries(new FormData(form));
      change({ q: values.q || '', brand: values.brand || '', sort: sorts.has(values.sort) ? values.sort : 'featured' });
    });
    on(form, 'change', event => {
      const key = event.target.name;
      if (key === 'brand' || key === 'sort') change({ [key]: event.target.value });
    });
    on(form, 'input', event => {
      if (event.target.name !== 'q') return;
      clearTimeout(timer);
      const value = event.target.value;
      timer = window.setTimeout(() => change({ q: value }, true), 150);
    });

    root.querySelectorAll(`[data-${prefix}-reset]`).forEach(control => on(control, 'click', event => {
      event.preventDefault();
      change({ q: '', brand: '', format: 'all', sort: 'featured' });
    }));
    on(more, 'click', () => { visible += PAGE_SIZE; render(); });
    const restore = () => { clearTimeout(timer); readHash(); visible = PAGE_SIZE; render(); };
    on(window, 'popstate', restore);
    on(window, 'hashchange', restore);
    const cleanup = () => {
      stopped = true;
      clearTimeout(timer);
      cancelAnimationFrame(frame);
      observer.disconnect();
      widthObserver?.disconnect();
      listeners.forEach(remove => remove());
      aligned.forEach(node => node.style.removeProperty('--ch-row-height'));
      mounted.delete(root);
      delete root.dataset[prefix + 'Mounted'];
    };
    mounted.set(root, cleanup);
    root.dataset[prefix + 'Mounted'] = 'true';
    root.dataset[prefix + 'Mode'] = 'enhanced';
    controls.hidden = false;
    if (pagination) pagination.hidden = true;
    readHash();
    render();
  }

  function mountWithin(container) {
    if (container.matches?.(`[data-${prefix}-hub]`)) mount(container);
    container.querySelectorAll(`[data-${prefix}-hub]`).forEach(mount);
  }

    return { mountWithin, unmountWithin(container) {
      if(container.matches?.(`[data-${prefix}-hub]`)) mounted.get(container)?.();
      container.querySelectorAll(`[data-${prefix}-hub]`).forEach(root=>mounted.get(root)?.());
    } };

  }
  const controllers=[{"prefix":"s1","formatKeys":["all","oils","balms","waters","gels","removers","sets"],"catalogueView":"cocomo-first-cleanse-data","shoppingId":"first-cleanse-products"},{"prefix":"s2","formatKeys":["all","gels","foams","powders","packs","sets"],"catalogueView":"cocomo-water-cleanse-data","shoppingId":"water-cleanse-products"},{"prefix":"s3","formatKeys":["all","pads","liquids","cleansers","peels","masks","pore-care","sets"],"catalogueView":"cocomo-step-03-data","shoppingId":"exfoliator-products"},{"prefix":"s4","formatKeys":["all","toners","pads","mists","sets"],"catalogueView":"cocomo-step-04-data","shoppingId":"toner-products"},{"prefix":"s5","formatKeys":["all","essences","powders","sets"],"catalogueView":"cocomo-step-05-data","shoppingId":"essence-products"},{"prefix":"s6","formatKeys":["all","serums","ampoules","mists","sets"],"catalogueView":"cocomo-step-06-data","shoppingId":"serums-ampoules-products"},{"prefix":"s7","formatKeys":["all","sheets","wash-off","peel-off","sleeping","patches","sets"],"catalogueView":"cocomo-step-07-data","shoppingId":"face-mask-products"},{"prefix":"s8","formatKeys":["all","creams","serums","patches","sets"],"catalogueView":"cocomo-step-08-data","shoppingId":"eye-care-products"},{"prefix":"s9","formatKeys":["all","creams","gels","lotions","balms","sets"],"catalogueView":"cocomo-step-09-data","shoppingId":"moisturiser-products"},{"prefix":"s10","formatKeys":["all","creams","fluids","gels","sticks","cushions","sprays","sets"],"catalogueView":"cocomo-step-10-data","shoppingId":"sunscreen-products"},{"prefix":"sp","formatKeys":["all","patches","gels","creams","powders","sets"],"catalogueView":"cocomo-spot-treatment-data","shoppingId":"spot-treatment-products"}].map(createController);
  const mountWithin=container=>controllers.forEach(controller=>controller.mountWithin(container));
  window.CocomoSkincareSteps={mountWithin};
  document.addEventListener('shopify:section:load',event=>mountWithin(event.target));
  document.addEventListener('shopify:section:unload',event=>controllers.forEach(controller=>controller.unmountWithin(event.target)));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mountWithin(document),{once:true});
  else mountWithin(document);
})();
  } catch(e) { console.error(e); }
})();

})();
